export default __webpack_public_path__ + "static/media/p05 p03.b32f1a0f.jpg";